import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import { useNavigate, Link } from "react-router-dom";
// import Footer from '../../common_components/Footer';
import VisitorHeader from '../../../common_components/visitor_module_header';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo"


class DelegateThankYou extends Component {
    // Intialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            geturl: "",
            is_partner: false,
            exhibitionAdd: '',
            exhibitionName: '',
            ExhRegistrationNo: '',
            fromDate: '',
            toDate: '',

            isClickValidation: false,
            scripts: [],
            QRList: [],
            isBadgeSend: false,
            VisitorRegistrationNoArr: [],
            dateToShow: ''
        }
        this.onPreviousClick = this.onPreviousClick.bind(this)

    }

    // componentWillUnmount() {
    //     const { isClickValidation } = this.state
    //     if (!isClickValidation) {
    //         sessionStorage.clear()
    //         window.location.replace('http://localhost:3000/#/');
    //     }
    // }
    componentWillUnmount() {
        const { isClickValidation, scripts } = this.state
        if (sessionStorage.getItem('loginDataSS') == null) {
            sessionStorage.clear()
            // if (!isClickValidation) {
            //     window.location.replace('http://localhost:3000/#/');
            // }

            if (scripts) {
                scripts.forEach((script) => {
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                });
            }
        }
    }


    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    // On Component Load
    componentDidMount() {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
            window.history.pushState(null, "", window.location.href);
        };
        if (sessionStorage.getItem('sessionExhibitionID') != null) {
            this.callGAScripts()
            console.log('JSON.parse(sessionStorage.getItem()', (sessionStorage.getItem('DelegateDataSS')))
            sessionStorage.setItem('completed', true);
            console.log('route : ', this.props);
            // Exhibition From Date
            // Exhibition From Date
            const dateString = sessionStorage.getItem('exhibitionDateFrom');

            const ExfromDate = dateString
                ? moment(dateString, 'DD/MM/YYYY').format('D MMMM YYYY')
                : '';

            console.log('dateString:', dateString);
            console.log('ExfromDate:', ExfromDate);


            // Exhibition To Date
            const dateString1 = sessionStorage.getItem('exhibitionDateTo');

            const ExtoDate = dateString1
                ? moment(dateString1, 'DD/MM/YYYY').format('D MMMM YYYY')
                : '';

            console.log('dateString1:', dateString1);
            console.log('ExtoDate:', ExtoDate);

            this.setState({
                geturl: sessionStorage.getItem('sessionExhMailWebsite') || '',
                exhibitionAdd: sessionStorage.getItem('exhibitionAddress') || '',
                exhibitionName: sessionStorage.getItem('sessionExhibitionName') || '',
                fromDate: ExfromDate,
                toDate: ExtoDate,
            }, () => {
                console.log(
                    'Dates:',
                    sessionStorage.getItem('exhibitionDateFrom'),
                    ExfromDate,
                    sessionStorage.getItem('exhibitionDateTo'),
                    ExtoDate
                );

                this.formatDateRange(this.state.fromDate, this.state.toDate);
            });
        }
    }

    // On Component Close
    // componentWillUnmount() {
    //     sessionStorage.clear()
    // }

    // On Previous
    onPreviousClick(e) {
        e.preventDefault();
        this.setState({ isClickValidation: true }, () => {
            const win = window.location.replace(this.state.geturl, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    }


    formatDateRange(start, end) {
        const startMoment = moment(start, 'D MMMM YYYY');
        const endMoment = moment(end, 'D MMMM YYYY');

        this.setState({
            dateToShow: `${startMoment.format('Do')} - ${endMoment.format('Do MMMM YYYY')}`
        });
    }

    render() {
        const { isLoading, exhibitionAdd, exhibitionName, fromDate, dateToShow, toDate } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <HeaderWithLogo />}
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <AdminDrawer />}
                {/* {console.log(!isLinkOpen)} */}
                <div className={!JSON.parse(sessionStorage.getItem('isLinkOpen')) && 'main-content app-content with-dr-container'}>
                    <VisitorHeader />
                    {/* <!-- CONTAINER --> */}
                    <div >
                        {/* <StepHeader /> */}

                        {/* <!-- ROW-1 --> {geturl}*/}
                        <div
                            className="main-content app-content mt-0">
                            <div className="side-app"> {!sessionStorage.getItem('sessionExhibitionID') ? (
                                <div className="container mt-5">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-8 col-lg-6">
                                            <div className="card text-center shadow-none mt-5">
                                                <div className="card-body py-5 text-center">

                                                    <div className="mb-3">
                                                        <span className="badge rounded-circle bg-success fs-3 px-4 py-3">
                                                            ✓
                                                        </span>
                                                    </div>

                                                    <h4 className="text-success mb-2">
                                                        Form Submitted Successfully
                                                    </h4>

                                                    <p className="text-muted text-center mb-0">
                                                        Thank you! Your form has already been submitted.
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ) : (
                                <div className="main-container container-fluid top-form-name" style={{ height: 'auto', overflow: 'visible', paddingBottom: '5rem' }}>
                                    <div className="thankyou-page mx-auto" style={{ marginTop: '10rem' }}>

                                        <img src={`../images/corner-top-img1.png`} class="corner-top" />

                                        <img src={`../images/corner-bottom-img.png`} class="corner-bottom" />

                                        <img src={`../images/corner-top-right-img.png`} class="top-design" />

                                        <img src={`../images/corner-top-left-img.png`} class="bottom-design" />

                                        <div class="main-content text-center">

                                            <div class="invite-box">
                                                <h1>INVITATION</h1>
                                            </div>

                                            <style>
                                                {`
                                                    @media (max-width: 768px) {
                                                        .logo-col-mobile {
                                                            margin-top: 20px !important;
                                                        }
                                                    }
                                                `}
                                            </style>
                                            <div class="row align-items-start justify-content-between mt-3">

                                                <div class="col-6 col-lg-3 col-md-4 col-sm-5 mb-3 logo-col-mobile" style={{ marginTop: "-60px" }}>
                                                    <div class="logo-card">
                                                        <img src={sessionStorage.getItem("sessionLogoPath")} alt="logo" />
                                                    </div>
                                                </div>

                                                <div class="col-6 col-lg-3 col-md-4 col-sm-5 mb-3 logo-col-mobile" style={{ marginTop: "-60px" }}>
                                                    <div class="logo-card">
                                                        <img src="../images/itme-right-logo.png" alt="logo" />
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="welcome-text">
                                                It is our pleasure to Invite & Welcome you to
                                            </div>

                                            <div class="event-title-wrapper">
                                                <div class="event-title">
                                                    {exhibitionName}
                                                </div>
                                            </div>

                                            <div class="event-date">
                                                {dateToShow},  {exhibitionAdd}
                                            </div>

                                            <div class="success-msg">
                                                Your {sessionStorage.getItem("delegateShowName") != null ? sessionStorage.getItem("delegateShowName") : 'Delegate'}  registration form is Submitted Successfully
                                            </div>

                                            <div class="registration-number">
                                                Your {sessionStorage.getItem("delegateShowName") != null ? sessionStorage.getItem("delegateShowName") : 'Delegate'}  Registration {sessionStorage.getItem('DelegateTypeID') == 10 ? 'Numbers are' : 'Number is'}  <br></br>
                                                {sessionStorage.getItem('DelegateTypeID') == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationNos : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationNo}
                                            </div>

                                            <div class="note-text" style={{ background: 'none', textAlign: 'center' }}>
                                                Note : Kindly check your registered email address for acknowledgement of application
                                            </div>
                                            <div classname="">
                                                <div classname="mt-1 mb-4">
                                                    <button
                                                        type="button"
                                                        className="btn btn-aqua"
                                                        onClick={(e) => this.onPreviousClick(e)}
                                                    >
                                                        BACK TO EVENT WEBSITE
                                                    </button>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>)}
                            </div>
                        </div>


                    </div>
                </div>
                {/* <Footer /> */}
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default DelegateThankYou
